import { useState, useCallback } from "react";
import { WIZARD_STEPS, TOTAL_STEPS } from "@/modules/client/loan-application/features/loan-origination/constants/wizard-steps";

/**
 * useWizardNavigation — manages the current wizard step and per-step validation.
 *
 * @param {object} options
 * @param {React.RefObject} options.stepperRef — ref to Syncfusion StepperComponent
 * @returns {{ currentStep, isFirstStep, isLastStep, goNext, goBack }}
 */
export default function useWizardNavigation({ stepperRef }) {
  const [currentStep, setCurrentStep] = useState(0);

  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === TOTAL_STEPS - 1;

  const goNext = useCallback(
    async methods => {
      const step = WIZARD_STEPS[currentStep];
      const isValid = await methods.trigger(step.fieldNames);
      if (!isValid) return false;

      stepperRef.current?.nextStep();
      setCurrentStep(prev => Math.min(prev + 1, TOTAL_STEPS - 1));
      return true;
    },
    [currentStep, stepperRef],
  );

  const goBack = useCallback(() => {
    stepperRef.current?.previousStep();
    setCurrentStep(prev => Math.max(prev - 1, 0));
  }, [stepperRef]);

  return { currentStep, isFirstStep, isLastStep, goNext, goBack };
}

